<button mat-button [matMenuTriggerFor]="menu">{{locale}}</button>
<mat-menu #menu="matMenu">

  @for (culture of cultures; track culture.locale) {
  <button mat-menu-item (click)="setLocale(culture.locale)">
    {{culture.nativeName}} ({{culture.englishName}})
  </button>
  }

</mat-menu>